import ParentDetail from "@/controllers/parent/parent-detail";

export default {
  extends: ParentDetail,
}
